"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VastaRX = void 0;
var VastaRX;
(function (VastaRX) {
    var vastaRXValues = {};
    var vastaRXGetters = {};
    var hash = function () {
        var retorno = "";
        var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        var charsLength = chars.length;
        for (var i = 0; i < 10; i++)
            retorno += chars.charAt(Math.floor(Math.random() * charsLength));
        return retorno;
    };
    VastaRX.getCurrentValue = function (key) {
        return vastaRXValues[key];
    };
    VastaRX.getState = function (key, callback) {
        if (!vastaRXGetters[key])
            vastaRXGetters[key] = [];
        var id = key + ":" + hash();
        vastaRXGetters[key].push({ id: id, callback: callback });
        callback(vastaRXValues[key]);
        return id;
    };
    VastaRX.setState = function (key, value) {
        vastaRXValues[key] = value;
        if (vastaRXGetters[key]) {
            for (var _i = 0, _a = vastaRXGetters[key]; _i < _a.length; _i++) {
                var getter = _a[_i];
                getter.callback(value);
            }
        }
    };
    VastaRX.unListen = function (identifier) {
        var _a = identifier.split(":"), chave = _a[0], id = _a[1];
        vastaRXGetters[chave] = vastaRXGetters[chave].filter(function (objeto) {
            return objeto.id.split(':')[1] !== id;
        });
        return id;
    };
})(VastaRX = exports.VastaRX || (exports.VastaRX = {}));
